import type { TitleStatus } from "./inventory";

/** Canonical workflow order for title statuses (earliest → latest). */
export const TITLE_STATUS_ORDER: TitleStatus[] = [
  "purchased_for_inventory",
  "bank_information",
  "payment_sent",
  "title_requested",
  "in_transit",
  "physical_title_received",
  "title_flip_required",
  "title_flip_not_required",
  "title_flip_in_progress",
  "title_flip_completed",
  "shipping_information",
  "title_shipped",
  "completed",
];

export const getTitleStatusIndex = (status: TitleStatus): number =>
  TITLE_STATUS_ORDER.indexOf(status);

/** True when current is at or past target in the canonical title workflow order. */
export const isTitleStatusAtOrAfter = (
  current: TitleStatus | undefined | null,
  target: TitleStatus,
): boolean => {
  if (!current) return false;
  const currentIndex = getTitleStatusIndex(current);
  const targetIndex = getTitleStatusIndex(target);
  if (currentIndex < 0 || targetIndex < 0) return false;
  return currentIndex >= targetIndex;
};
